<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden="true"
    class="g-icon-alert-circle"
  >
    <path
      d="M13.3333 7.33333C13.3333 4.01962 10.647 1.33333 7.33333 1.33333C4.01962 1.33333 1.33333 4.01962 1.33333 7.33333C1.33333 10.647 4.01962 13.3333 7.33333 13.3333C10.647 13.3333 13.3333 10.647 13.3333 7.33333ZM7.33984 9.33333C7.70803 9.33333 8.00651 9.63181 8.00651 10C8.00651 10.3682 7.70803 10.6667 7.33984 10.6667H7.33333C6.96514 10.6667 6.66667 10.3682 6.66667 10C6.66667 9.63181 6.96514 9.33333 7.33333 9.33333H7.33984ZM6.66667 8V4.66667C6.66667 4.29848 6.96514 4 7.33333 4C7.70152 4 8 4.29848 8 4.66667V8C8 8.36819 7.70152 8.66667 7.33333 8.66667C6.96514 8.66667 6.66667 8.36819 6.66667 8ZM14.6667 7.33333C14.6667 11.3834 11.3834 14.6667 7.33333 14.6667C3.28325 14.6667 0 11.3834 0 7.33333C0 3.28325 3.28325 0 7.33333 0C11.3834 0 14.6667 3.28325 14.6667 7.33333Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 16
})
</script>

<style scoped>
.g-icon-alert-circle {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
